<div class="{{theme}}-theme audio-parent" *ngIf="intro">
    <div class="position-relative border-bottom" *ngIf="intro">

        <img src="{{intro.featureImageUrl}}" class="d-none d-lg-block img-right featured-img" />

        <div class="intro">
            <div class="container-fluid py-4">

                <div class="row">
                    <div class="col-12">
                        <h1 class="py-4" [innerHTML]="intro.title"></h1>
                    </div>
                </div>
                <audio-transcript [source]="intro.audioUrl" [transcript]="intro.transcript"></audio-transcript>
                <div class="py-4 d-lg-none ">
                    <img src="{{intro.featureImageUrl}}" class="featured-img" />
                </div>
                <div *ngFor="let content of intro.contents" class="py-3 section-content">
                    <ng-container *ngIf="content.discriminator == 'HtmlText'">
                        <div class="row">
                            <div class="offset-2 col-10" [innerHTML]="content.text"></div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="content.discriminator == 'Image'">
                        <div class="row">
                            <div class="col-12 offset-md-2 col-md-10 col-lg-8 pr-lg-0">
                                <img src="{{content.imageUrl}}" class="w-100 img-fluid" />
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>
